import { Image } from 'expo-image';
import { useEffect, useMemo, useRef, useState } from 'react';
import {
  View, Text, StyleSheet, TouchableOpacity, ActivityIndicator, TextInput
} from 'react-native';
import Entypo from '@expo/vector-icons/Entypo';
import { Button, Modal, Toast } from 'native-base';
import { useNavigation } from '@react-navigation/native';
import { useTypedSelector } from '../redux/store';
import { UserAPI } from '../data/api';

export default function ActivityScreen() {
  const [load, setLoad] = useState(true);
  const userCurrent = useTypedSelector((state) => state.userCurrent);
  const userInfo = useTypedSelector(state=> state.userInfo );
  const navigation = useNavigation();
  const inputRef = useRef<TextInput>(null);

  const [inputValue, setInputValue] = useState("");
  const [invitedList, setInvitedList] = useState<{email: string, id: number}[]>([]);
  
  const goProfile = ()=>{
    navigation.navigate("Profile", {});
  };

  const copyCode = ()=>{
    if(!inputValue) return;
    if(typeof window !== "undefined"){
      window.navigator.clipboard.writeText(inputValue); 
      Toast.show({
        title: "Invitation link copied",
        placement: "top",
        bgColor: "rgba(0,255,0,0.4)",
      });
    }
  };

  const getInviteCode = async ()=>{
    if(!userInfo || userInfo.is_anonymous){ return; }
    let path = "";
    if(typeof window !== "undefined"){
      path = window.location.href.split("?")[0];
      path += "?invite_code=" + userCurrent.invitation_code || "";
    }
    setInputValue(path);

    let res = await UserAPI.getUserInvitation();
    setLoad(false);
    if(typeof res === "string"){ return; }
    setInvitedList(res);
    // if(inputRef.current){ console.log([inputRef.current]); inputRef.current.setNativeProps({ text: path }); }
  };

  useEffect(()=>{
    getInviteCode();
  }, [userInfo]);

  return (
    <View style={styles.container}>
      <Button style={{
        backgroundColor: "rgba(0,0,0,0.5)",
        borderRadius: 100, position: "absolute",
        top: 10, left: 10, padding: 4, zIndex: 9,
      }} onPress={()=> navigation.goBack() }>
        <Entypo name="chevron-left" size={24} color="#FFFFFF" />
      </Button>
      <View style={{ alignItems: "center", marginTop: 60 }}>
        {/* <Image style={{ width: 80, height: 80 }}
          source={ require('../assets/material/more-coin.png') }
        /> */}
        <Image style={{ width: 100, height: 100 }}
          source={ require('../assets/gift1.png') }
        />
        <View style={{ alignItems: "center", marginTop: 8 }}>
          <Text style={{ color: "#FFFFFF", fontSize: 24, fontWeight: "bold"}}>
            💸 Invite New Users! 💸
          </Text>
          <Text style={{ color: "#FFFFFF", fontSize: 16, textAlign: "center", marginTop: 10 }}>
            💰 both you and your friend get 100 coins
          </Text>
        </View>
      </View>
      
      { !userInfo || userInfo.is_anonymous ? (
        <View style={{ padding: 30 }}>
          <View style={{ marginBottom: 10 }}>
            <Text style={{ fontSize: 14, color: "#FFFFFF", fontWeight: "bold" }}>
              Create an account to obtain an invitation code
            </Text>
          </View>
          <TouchableOpacity style={{
            height: 40, borderRadius: 10, paddingLeft: 10, paddingRight: 10,
            backgroundImage: "linear-gradient(to bottom, rgb(148,9,255), rgb(173,8,255))",
            flexDirection: "row", gap: 10, marginBottom: 6,
            alignItems: "center", justifyContent: "center"
          }} onPress={goProfile}>
            <Text style={{
              fontSize: 18, color: "#FFFFFF", fontWeight: "700"
            }}>
              Sign In
            </Text>
          </TouchableOpacity>
        </View>
      ) : (
        <View style={{ padding: 30, paddingLeft: 20, paddingRight: 20 }}>
          <View style={{
            flexDirection: "row", gap: 10, alignItems: "center",
          }}>
            <TextInput placeholder="... ..." placeholderTextColor="#999999"
              ref={inputRef}
              value={inputValue}
              readOnly style={{
                flex: 1, height: 40, backgroundColor: "rgb(33,35,58)",
                borderRadius: 10, paddingLeft: 10, paddingRight: 10,
                color: "#FFFFFF", fontSize: 16,
                borderWidth: 2,
                borderColor: "rgb(179,88,251)"
              }} />
            <TouchableOpacity style={{
              height: 40, borderRadius: 8, paddingLeft: 10, paddingRight: 10,
              backgroundImage: "linear-gradient(to bottom, rgb(148,9,255), rgb(173,8,255))",
              flexDirection: "row", alignItems: "center",
            }} onPress={copyCode}>
              <Text style={{ fontSize: 16, color: "#FFFFFF", fontWeight: "700" }}>
                Copy Link
              </Text>
            </TouchableOpacity>
          </View>
          <View style={{
            paddingTop: 20, marginTop: 20,
            borderWidth: 2, borderColor: "rgb(179,88,251)",
            borderRadius: 10, padding: 10,
          }}>
            <View>
              <Text style={{ fontSize: 16, color: "#FFFFFF", fontWeight: "bold", textAlign: "center" }}>
                Invited Users
              </Text>
            </View>
            <View style={{ padding: 10 }}>
              { invitedList.map((item, index)=>(
                <Text key={item.id} style={{ fontSize: 14, color: "#FFFFFF", marginBottom: 6 }}>
                  {item.email}
                </Text> 
              )) }
            </View>

            {load && (
              <View style={{
                flexDirection: "row", gap: 10, justifyContent: "center",
                paddingTop: 20, paddingBottom: 20
              }}>
                <ActivityIndicator size="large" color="rgb(173, 8, 255)" />
              </View>
            )}
            {!load && !invitedList.length && (
              <View style={{
                flexDirection: "row", gap: 10, justifyContent: "center",
                paddingTop: 20, paddingBottom: 20
              }}>
                <Text style={{ fontSize: 16, color: "#CCC", textAlign: "center" }}>
                  No invited users yet
                </Text>
              </View>
            )}
          </View>
        </View>
      ) }
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#191B2C',
  }
});